module.exports = __webpack_public_path__ + "img/battery.4df17964.svg";